<template>
  <el-dialog
    v-if="isShow"
    :title="typeof location.id !== 'undefined' ? 'Edit Location' : 'Create Location'"
    :visible.sync="isShow"
    width="80%"
    top="5vh"
    :fullscreen="isFullscreen"
  >
    <el-form
      ref="locationForm"
      v-loading="isSaving"
      :rules="rules"
      :model="location"
    >
      <el-row>
        <el-col :md="24">
          <el-row>
            <el-col :md="24">
              <el-form-item
                label="Name"
                prop="name"
              >
                <el-input
                  v-model="location.name"
                  placeholder="Name (e.g. Head Office, Branch Company)"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="24">
              <el-form-item
                label="Address"
                prop="address"
              >
                <el-input
                  v-model="location.address"
                  placeholder="E.g. Unit 10, 33 Main Road"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="8">
              <el-form-item
                label="Suburb"
                prop="suburb"
              >
                <el-autocomplete
                  v-model="location.suburb"
                  :fetch-suggestions="suburbQuerySearch"
                  placeholder="Enter name of suburb"
                  :trigger-on-focus="false"
                  class="w-100"
                  placement="top"
                  :debounce="500"
                  clearable
                  @select="handleSelectSuburb"
                >
                  <template v-slot="{ item }">
                    {{ formatSuburbByLocation(item) }}
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="State"
                prop="state"
              >
                <el-input
                  v-model="location.state"
                  placeholder="E.g. Victoria"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item
                label="Postcode"
                prop="postcode"
              >
                <el-input
                  v-model="location.postcode"
                  placeholder="E.g. 3000"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Contact"
                prop="contact"
              >
                <el-input
                  v-model="location.contact"
                  placeholder="E.g. John Smith"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Phone"
                prop="phone"
              >
                <el-input
                  v-model="location.phone"
                  placeholder="E.g. 03 9700 5555"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :md="12">
              <el-form-item
                label="Fax"
                prop="fax"
              >
                <el-input
                  v-model="location.fax"
                  placeholder="E.g. 03 9700 5555"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Email"
                prop="email"
                :rules="[{ type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }]"
              >
                <el-input
                  v-model="location.email"
                  placeholder="E.g. john.smith@company.com"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="24">
              <el-form-item
                label="Notes"
                prop="notes"
              >
                <el-input
                  v-model="location.notes"
                  type="textarea"
                  :rows="4"
                  placeholder="Notes"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShow = false">
        Cancel
      </el-button>
      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof location.id !== 'undefined' ? updateLocation() : createLocation()"
      >
        {{ typeof location.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      location: {},
      isShow: false,
      isSaving: false,
      isFullscreen: false,
      rules: {
        name: [
          { required: true, message: 'Name of the location is required', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Address of the location is required', trigger: 'blur' }
        ],
        suburb: [
          { required: true, message: 'Please enter and select a suburb from the list', trigger: 'change' }
        ],
        state: [
          { required: true, message: 'State of the location is required', trigger: 'change' }
        ],
        postcode: [
          { required: true, message: 'Postcode of the location is required', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    createLocation () {
      this.$refs.locationForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.$sdk.account_location.create(this.location, builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    },
    updateLocation () {
      this.$refs.locationForm.validate((valid) => {
        if (valid) {
          this.isSaving = true
          this.location.update(builder => {
            builder.context = { resource: 'account', id: this.accountId }
          })
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.isShow = false
              this.$emit('saved')
            })
        }
      })
    },
    suburbQuerySearch (queryString, cb) {
      this.$sdk.dictionary_location.list(builder => {
        builder.page = 1
        builder.limit = 50
        builder.filters = { dictionary_location_find: [queryString] }
        builder.order = 'suburb:asc'
      }).then(res => {
        cb(res)
      })
    },
    handleSelectSuburb (item) {
      this.location.suburb = item.suburb
      this.location.state = item.state
      this.location.postcode = item.postcode
    },
    formatSuburbByLocation (location) {
      if (location) {
        return `${location.suburb}, ${location.state}, ${location.postcode}`
      } else return ''
    }
  }
}
</script>

<style>

</style>
